<template>
  <div v-loading="salesOrder.detailItemsLoading">
    <el-form style="margin:0px;">
      <el-row :gutter="20" class="hidden-md-and-down" style="height:">
        <div class="mb-10" v-if="editControls" style="height:30px;">
          <div v-if="selectedProducts.length > 0">
          <span class="mr-10 fs-14">
            {{$t('sales_orders.products')}} <i class="el-icon-arrow-right"></i> {{$t('sales_orders.selected')}}
          </span>
          <span class="bg-accent-lighter b-rad-18 p-8 fs-14">
            {{selectedProducts.length}}
          </span>
          <el-dropdown
            size="small"
            split-button
            type="primary"
            class="ml-20">
            {{$t('common.actions')}}
            <el-dropdown-menu slot="dropdown">
             <el-dropdown-item @click.native="handleRemoveLines"><i class=""></i>{{$t('sales_orders.removeProduct')}}</el-dropdown-item>
             <el-dropdown-item @click.native="handleaddRebates"><i class=""></i>{{$t('sales_orders.applyRebate')}}</el-dropdown-item>
             <el-dropdown-item @click.native="handleRemoveRebates"><i class=""></i>{{$t('sales_orders.removeRebate')}}</el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
        </div>
      </div>
        <el-table
          :data="items"
          :empty-text="$t('sales_orders.noProductAdded')"
          style="width:100%;"
          :row-class-name="tableRowClassName"
          ref="products"
          @selection-change="handleSelectionChange"
          :cell-style="{padding:'2px'}">
          <el-table-column
            v-if="editControls"
            type="selection"
            width="55">
          </el-table-column>
          <el-table-column :label="productLabel">>
            <template slot-scope="scope">
              <div style="margin-top:10px;width:100%;word-break:break-word;">
                <SalesProductDefinition
                  :product="scope.row.product"
                  :inventory="scope.row.product.inventory"
                  :reservation="scope.row.reservation"
                  :vintage="getVintage(scope.row)" />
              </div>
            </template>
          </el-table-column>
          <el-table-column prop="qty" :label="quantityLabel" width="120" align="center">
            <template slot-scope="scope">
                  <span class="fs-14 secondary-text" v-if="!editControls" >{{scope.row.qty}} </span>
                    <el-tooltip :content="$t('sales_orders.quantityNotAvailable')" placement="top" effect="light" :manual="true" :value="scope.row.validations!=null && scope.row.validations.length>0">
                      <unitQuantities
                        v-if="editControls"
                        @change="v => $emit('quantityChange',{uuid:scope.row.uuid, quantity:v})"
                        :default_unit="2"
                        :default="scope.row.qty"
                        :product_unit="scope.row.product.unit"
                        :product_uvc="scope.row.product.uvc"
                        :showUnitControl="scope.row.product.uvc!=null">
                      </unitQuantities>
                    </el-tooltip>
            </template>
          </el-table-column>
          <el-table-column :label="$t('sales_orders.price')"  align="center">
            <template slot-scope="scope">
                <span class="fs-14" v-if="scope.row.prices != null && scope.row.prices.length>1" >{{$n(unitPrice(scope.row), 'currency')}}</span>
                <div v-for="(price, index) in scope.row.prices" :key="index">
                  <span class="fs-14 secondary-text" v-if="!price.editState">
                    <span><span v-if="scope.row.prices != null && scope.row.prices.length>1" class="fs-14">{{$t("sales_orders.price_label."+price.label)}} : </span>{{$n(price.price,'currency')}}</span>

                    <span v-if="price.taxable">+tx</span>
                    <el-button size="mini" v-if="$can('manage', 'SalesOrders') && editControls" type="text" @click="editItemPrice({uuid : scope.row.uuid, action:'show', index});">
                      <i class="el-icon-edit"></i>
                    </el-button>
                  </span>
                  <el-input-number
                    :ref="'price_'+index+'_'+scope.row.uuid"
                    @keyup.enter.native="editItemPrice({uuid : scope.row.uuid, action:'hide', index});"
                    @change="v=>{$emit('changePrice',{uuid:scope.row.uuid, price:v, priceIndex:index})}"
                    @blur="editItemPrice({uuid : scope.row.uuid, action:'hide', index})"
                    :value="price.price"
                    v-if="price.editState"
                    :controls="false"
                    size="small"
                  ></el-input-number>
                </div>
            </template>
          </el-table-column>
          <el-table-column :label="$t('sales_orders.rebate')" width="150" align="center" >
            <template slot-scope="scope">
              <div v-if="editControls">
                <el-link :underline="false" type="primary" slot="reference" @click="openRebateCreditDrawer(scope.row)">
                  <i class="el-icon-circle-plus" v-if="scope.row.discount == null || (scope.row.discount != null && scope.row.discount.amount==null)"></i>
                  <span v-if="scope.row.discount != null && scope.row.discount.type==1">{{scope.row.discount.value}}%</span>
                  <span v-else>
                    <span v-if="scope.row.discount != null && scope.row.discount.netType=='UNIT'">{{scope.row.discount.value}}$ / b.</span>
                    <span v-if="scope.row.discount != null && scope.row.discount.netType=='TOTAL'">{{scope.row.discount.value}}$</span>
                  </span>
                </el-link>
              </div>
              <div v-else>
                <Discount :discount="scope.row.discount" classe=""/>
              </div>
            </template>
          </el-table-column>
          <el-table-column :label="$t('sales_orders.total')" width="150" align="right">
            <template slot-scope="scope">
                  <span class="fs-14" >{{$n(scope.row.subTotalBrut,'currency')}}<br> </span>
                  <span v-if="scope.row.discount !=null && scope.row.discount.amount != null">({{$n(scope.row.discount.amount,'currency')}}) </span>
            </template>
          </el-table-column>
          <el-table-column label="" width="100" align="right" v-if="editControls">
            <template slot-scope="scope">
                  <el-button type="text" icon="el-icon-delete" @click="$emit('remove', scope.$index)"></el-button>
            </template>
          </el-table-column>
        </el-table>
      </el-row>
      <el-row class="hidden-lg-and-up">


        <h5>{{$t('sales_orders.salesOrderDetail')}}</h5>
        <p v-if="items.length==0" class="fs-14 secondary-text" style="text-align:center;">{{$t('sales_orders.noProductAdded')}}</p>
        <el-card v-for="(item, index) in items" :key="item.id" shadow="never" class="mb-5">
          <el-row v-if="editControls">
            <el-button type="text" icon="el-icon-delete" @click="$emit('remove',index)" style="float:right;z-index:1000;" class="m-0 p-0"></el-button>
          </el-row>

          <el-row>
            <span class="secondary-text- fs-14">
              <span v-if="showMoreIndex!=index || (showMoreIndex == index && !editControls)">{{item.qty}} x </span>
              <SalesProductDefinition
                :showProductIcon="false"
                :product="item.product"
                :inventory="item.product.inventory"
                :reservation="item.reservation"
                :vintage="getVintage(item)" />
            </span>
            <span v-if="item.provider!=null && showMoreIndex==index" class="fs-14">, {{customerName(item.provider)}}</span>
          </el-row>
          <el-row v-if="showMoreIndex==index && editControls" >
            <!-- <el-divider /> -->
            <unitQuantities  v-if="editControls" @change="v => $emit('quantityChange',{uuid:item.uuid, quantity:v})" :default="item.qty"  :product_unit="item.unit" :product_uvc="item.uvc" :showUnitControl="item.uvc!=null"></unitQuantities>
          </el-row>
          <!-- <el-divider class="mt-0 mb-0" v-if="showMoreIndex==index"/> -->
          <el-row >
              <span v-if="item.prices != null && item.prices.length > 1" class="fs-14 secondary-text">Prix : {{$n(unitPrice(item), 'currency')}}<br></span>
              <span>
                <span v-for="(price, index) in item.prices" :key="index" >
                  <br v-if="index > 0"/>
                  <span class="fs-14 secondary-text" style="line-height:px;" v-if="!price.editState">
                    <span v-if="item.prices != null && item.prices.length > 1">{{$t("sales_orders.price_label."+price.label)}} : </span>
                    <span v-if="item.prices != null && item.prices.length == 1">Prix : </span>
                    {{price.price}}
                    <span v-if="price.taxable">+tx</span>
                    <el-button v-if="$can('manage', 'SalesOrders') && editControls" type="text" @click="editItemPrice({uuid : item.uuid, action:'show', index});">
                      <i class="el-icon-edit"></i>
                    </el-button>
                  </span>
                  <el-input-number
                    :ref="'price_'+index+'_'+item.uuid"
                    @keyup.enter.native="editItemPrice({uuid : item.uuid, action:'hide', index});"
                    @change="v=>{$emit('changePrice',{uuid:item.uuid, price:v, priceIndex:index})}"
                    @blur="editItemPrice({uuid : item.uuid, action:'hide', index})"
                    :value="price.price"
                    v-if="price.editState"
                    :controls="false"
                    size="small">
                  </el-input-number>
                </span>
              </span>
          </el-row>
          <!-- <el-divider class="mt-0 mb-0" v-if="showMoreIndex==index"/> -->
          <el-row >

            <div v-if="editControls">
              <el-link :underline="false" type="primary" slot="reference" @click="openRebateCreditDrawer(item)" :disabled="showMoreIndex!=index">
                <span class="secondary-text fs-14">{{$t('sales_orders.rebateField')}}</span><i class="el-icon-circle-plus" v-if="(item.discount == null || (item.discount != null && (item.discount.amount==null || item.discount.amount==0)))  && showMoreIndex==index"></i><span v-if="(item.discount == null || ( item.discount != null && (item.discount.amount==null || item.discount.amount==0)))  && showMoreIndex!=index"> -- </span>
                <span v-if="item.discount != null && item.discount.type==1">{{item.discount.value}}%</span>
                <span v-if="item.discount != null && item.discount.type==1"> ({{$n(item.discount.amount,'currency')}})</span>
                <span v-else>
                  <span v-if="item.discount != null && item.discount.netType=='UNIT'">{{item.discount.value}}$ / b.</span>
                  <span v-if="item.discount != null && item.discount.netType=='NET'">{{item.discount.value}}$</span>
                </span>
              </el-link>
            </div>
            <div v-else>

              <span v-if="item.discount == null || (item.discount != null && item.discount.amount==null)" class="secondary-text fs-14">{{$t('sales_orders.rebateField')}} -- </span>
              <div v-else>
                <span v-if="item.discount != null  && item.discount.type==1" class="secondary-text fs-14"> {{$t('sales_orders.rebateField')}} {{item.discount.value}}%</span>
                <span v-if="item.discount != null  && item.discount.type==1" class="secondary-text fs-14"> ({{$n(item.discount.amount,'currency')}})</span>
                  <span v-else>
                    <span v-if="item.discount != null  && item.discount.netType=='UNIT'" class="secondary-text fs-14">{{$t('sales_orders.rebateField')}} {{item.discount.value}}$ / b.</span>
                    <span v-else class="secondary-text fs-14">{{$t('sales_orders.rebateField')}} {{item.discount.amount}}$</span>
                  </span>
              </div>
            </div>
          </el-row>
          <!-- <el-divider class="mt-0 mb-0" v-if="showMoreIndex==index"/> -->
          <el-row >
              <span class="secondary-text fs-14">{{$t('sales_orders.totalField')}} {{$n(item.subTotal,'currency')}}</span>
          </el-row>
          <el-row style="text-align:center;">
            <el-button type="text" v-if="showMoreIndex!=index" @click="showMore(index)"><i class="el-icon-arrow-down"></i></el-button>
            <el-button type="text" v-if="showMoreIndex==index" @click="showMore(null)"><i class="el-icon-arrow-up"></i></el-button>
          </el-row>
        </el-card>
      </el-row>
    </el-form>
    <RebateDrawer :visible="rebateDrawerVisible" :rebateToEdit="rebateToEdit" :itemUuid="rebateOnItemUuid" @close="closeRebateCreditDrawer" @update="v=> handleChangeDiscount({discount:v.rebate,uuid:v.itemUuid})"> </RebateDrawer>
  </div>
</template>
<script>
import { mapState, mapGetters } from 'vuex';
import unitQuantities from '@/components/product/unit-quantities';
import RebateDrawer from '@/components/sales-order-rebate-drawer';
import UnitFormatVolumeLabel from '@/components/product/unitFormatVolumeLabel'
import SalesProductDefinition from './sales-product-definition'
import Discount from '@/components/discount'

export default {
	name: 'SalesOrderItemsEditor',
  props: {
    items : {
      type : Array,
      require : true
    },
    editControls : {
      type : Boolean,
      default : false
    },
    packages : {
      type : Array,
    }
	},
	data() {
		return {
      selectedPuid : null,
      selectedInventoryId : null,
      rebateDrawerVisible : false,
      rebateOnItemUuid : null,
      rebateToEdit :null,
      showMoreIndex : null,
      selectedProducts: [],
      multipleLineRebate : false,
	   }
   },
   components : {
     unitQuantities,
     RebateDrawer,
     UnitFormatVolumeLabel,
     SalesProductDefinition,
     Discount
   },
   methods : {
     getVintage (line) {
       let vintages = [];
       const packageObj = _.find(this.packages, pck => _.get(pck, 'inventory.id') === _.get(line, 'product.inventory.id'));
       if (packageObj != null) {
         _.forEach(packageObj.lines, l => {
           if (l.item.puid === line.puid) {
             if (_.get(l, 'item.extraInfo.vintage') != null) {
               vintages.push(_.get(l, 'item.extraInfo.vintage'));
             }
           }
         })
       }

       if (vintages.length === 0) return null;
       return _.join(vintages, ',');
     },
     handleChangeDiscount ({discount ,uuid}) {
       if (this.multipleLineRebate === true) {
         this.$emit('applyDiscount', {discount, selectedLines: this.selectedProducts});
       } else {
         this.$emit('changeDiscount',{discount,uuid})
       }
     },
     handleaddRebates () {
      this.multipleLineRebate = true;
      this.openRebateCreditDrawer();
     },
     handleRemoveLines () {
       this.$confirm('Êtes vous certain de vouloir supprimer les produits de la commande?', 'Attention', {
           confirmButtonText: 'Oui',
           cancelButtonText: 'Annuler',
           type: 'warning'
         }).then(() => {
            this.$emit('removeLines', this.selectedProducts);
         }).catch((err) => {
           // Do nothing
         })

     },
     handleRemoveRebates () {
       this.$emit('removeRebates', this.selectedProducts);
     },
     handleSelectionChange (val) {
       this.selectedProducts = val;
     },
     tableRowClassName({row, rowIndex}){
       if((!_.isEmpty(row.validations)) || row.validations == null && row.quantityAvailable === false){
         return 'bg-danger-lighter';
       }
       return '';
     },
     showMore(index){
       this.showMoreIndex=index;
     },
     openRebateCreditDrawer(item){
       if(_.get(item, 'discount.amount') != null){
         this.rebateToEdit = item.discount;
       }else{
         this.rebateToEdit=null;
       }
       this.rebateOnItemUuid = _.get(item, 'uuid');
       this.rebateDrawerVisible=true
     },
     closeRebateCreditDrawer(){
       this.rebateDrawerVisible = false;
       this.multipleLineRebate = false;
     },
     unitPrice(item){
       let price = 0.00;
       _.forEach(item.prices, p=>{
         price+=p.price;
       })
       return price;
     },
     editItemPrice({uuid , action, index}){
       this.$emit('editPrice',{uuid, action, index});
       if(action==="show"){
         this.$emit('edition', true);
         this.$nextTick(() => {
           if(this.$refs['price_'+index+'_'+uuid]){
             this.$refs['price_'+index+'_'+uuid][0].focus()
           }
         })
       } else {
         this.$emit('edition', false);
       }
     },
     getInStockQty(item){
       if(item.quantities!=null){
         return item.quantities.in_stock;
       }else{
         return "";
       }
     },
     openCustomer(customerId, tab){
       var index='/customers/'+customerId+"?activeTab="+tab;
       this.$router.push(index);
     },
     creditItemPopover(item){
       return "Un crédit de " + item.credit + "$ sera émis pour ce produit.";
     },
   },
   computed: {
     productLabel () {
       return `${this.$i18n.t('sales_orders.product')} (${this.nbLines})`;
     },
     quantityLabel () {
       return `${this.$i18n.t('sales_orders.quantity')} (${this.totalQuantities})`;
     },
     nbLines () {
       if (this.items != null) {
         return this.items.length;
       }
       return 0;
     },
     totalQuantities (){
       let count = 0;
       _.forEach(this.items, (l) => {
         count += l.qty;
       })
       return count;
     },
     ...mapState('salesOrderEditor', ['salesOrder']),
     ...mapGetters('salesOrders', ['customerName']),
     ...mapGetters('inventory', ['isMultipleInventorySystem'])
  },
  mounted(){
    this.$refs.products.$options._parentVnode.elm.classList.remove('el-table--enable-row-hover')
  }

}
</script>
<style lang="scss" scoped>
@import '../../assets/scss/_variables';


</style>
